<template>
  <div class="course_table grey loading_table">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    <b-table
      default-sort="name"
      pagination-simple
      per-page="15"
      :data="filteredCoursesList"
      paginated
      @click="openInfo"
      @sort="initSort"
      backend-sorting
    >
      <template slot-scope="props">
        <b-table-column label="Название курса" :visible="true" field="name" :centered="false" sortable width="30%">
          <div>{{ props.row.name }}</div>
        </b-table-column>
        <b-table-column label="Категория" :visible="true" field="categories" :centered="false" sortable width="20%">
          <div>{{ props.row.category_name }}</div>
        </b-table-column>
        <b-table-column label="Статус" :visible="true" field="status" :centered="false" sortable width="20%">
          <div>{{ setStatus(props.row.user_course_status) }}</div>
        </b-table-column>
        <b-table-column label="Дата начала" :visible="true" field="date_start" :centered="false" sortable width="15%">
          <div>{{ props.row.date_start | moment('DD.MM.YYYY') }}</div>
        </b-table-column>
        <b-table-column label="Окончание" :visible="true" field="date_end" :centered="false" width="15%">
          <div>{{ props.row.date_end }}</div>
        </b-table-column>
        <!-- <b-table-column label="Прогресс" :visible="true" field="progress" :centered="false" sortable>
               <div @click="openInfo(props.row)">---</div>
            </b-table-column> -->
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    categoriesList: {
      default: () => [],
      type: Array
    },
    coursesList: {
      default: () => [],
      type: Array
    },
    isLoading: {
      default: () => true,
      type: Boolean
    }
  },
  computed: {
    filteredCoursesList() {
      let data = this.coursesList
      data.forEach((course) => {
        course['date_end'] = this.$moment(course.date_start).add(course.days_limit, 'days').format('DD.MM.YYYY')
        course['category_name'] = this.categoriesList.find((el) => el.id === course.category_id).name
      })
      return data
    }
  },
  methods: {
    initSort(fieldName, sortType) {
      this.$emit('init-sort', fieldName, sortType)
    },
    openInfo(val) {
      this.$emit('click', val.id)
    },
    setStatus(status) {
      switch (status) {
        case 0:
          return 'Назначен'
        case 1:
          return 'В процессе'
        case 2:
          return 'Пройден'
        case 3:
          return 'Не пройден'
      }
    }
  }
}
</script>
